// extracted by mini-css-extract-plugin
module.exports = {"Container":"FacebookLogin_Container__2x4iZ","Picture":"FacebookLogin_Picture__2UpJN"};